import React from 'react';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AppNavButton from './Components/AppNavButton';

const AppointeeManagementNav = () => {
	return (
		<AppNavButton text="Appointee Management" showGroupingMenu={true} path="/appointeemanagement" icon={<AssignmentIndIcon />} />
	);
};

export default AppointeeManagementNav;
